<template>
  <div>
    <search-bar @search="doSearch" @clear="doClear" :full-width="true" :query="mode.search.q" :doing="mode.search.doing"></search-bar>
    <panel title="Prospects" :footerShow="true">
      <div slot="headingElements">
          <router-link :to="{'name': 'prospects.create'}" class="btn btn-success"><i class="icon-add"></i> <span class="text-semibold">Add prospect</span></router-link>
      </div>
      <div>
        <table class="dataTable table table-hover tasks-list text-nowrap" role="grid">
          <thead>
          <tr role="row">
            <th tabindex="0" rowspan="1" colspan="1" style="width: 20px;">#</th>
            <th tabindex="0" rowspan="1" colspan="1">Name</th>
            <th tabindex="0" rowspan="1" colspan="1">Email</th>
            <th tabindex="0" rowspan="1" colspan="1">Phone</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="!items.length" class="active border-double">
            <td colspan="6" class="text-semibold text-center">No data available</td>
          </tr>
          <template v-for="(item, idx) in items">
            <tr role="row" class="border-top-dashed-2px" v-bind:class="{'even': idx === 0 || idx % 2 === 0, 'odd': idx % 2}" :key="item.id" data-toggle="collapse" :data-target="'#u'+idx">
              <td>
                <div v-if="item.profile.logo"><img class="img-circle img-md" :src="item.profile.logo.preview"/></div>
                <div v-else><img class="img-circle img-md" :src="require('@/assets/images/placeholder.jpg')"/></div>
              </td>
              <td>
                <div class="text-semibold">{{item.profile.first_name}} {{item.profile.last_name}}</div>
              </td>
              <td>
                <div class="text-semibold"><a @click.prevent="$router.push({'name': 'prospects.details', params: {'oid': item.id}})">{{item.email}}</a></div>
              </td>
              <td>
                <div class="text-semibold">{{item.profile.phone}}</div>
              </td>
              <td>
                <ul class="icons-list">
                  <li><a title="View details" @click.prevent="$router.push({'name': 'prospects.details', params: {'oid': item.id}})"><i class="icon-eye"></i></a></li>
                  <li v-if="_can('updateUser')"><a href="#" @click.prevent="deleteItem(item.id)" title="Delete prospect"><i class="icon-trash"></i></a></li>
                </ul>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
      <div slot="footerElements">
        <div class="col-sm-12">
          <pagination :page="paging.page" :itemsPerPage="paging.perPage" :maxVisiblePage="5" :totalItems="paging.total" @page-change="__pageChanged"/>
        </div>
      </div>
    </panel>
  </div>
</template>

<script>
import Vue from 'vue'

import ProspectService from '@/services/prospect.service'

import listMixin from '@/helpers/mixins/_listMixin'
import SearchBar from '../_partial/search-bar'

export default {
  components: { SearchBar },
  name: 'ProspectIndex',
  mixins: [listMixin],

  data () {
    return {
      id: null,
      itemTemplate: {},
      service: ProspectService
    }
  },

  mounted () {
  },

  methods: {
    deleteItem (id) {
      this.$popup.confirm('Are you sure you want to remove this prospect data?', 'Prospect delete').then(() => {
        this.service.drop(id, (result) => {
          this.refresh()
        })
      })
    },

    reset (forceItemsReset = true) {
      this.id = null
      this.groupStatuses = Vue.config.statusGroups['user'] ? Vue.config.statusGroups['user'] : Vue.config.statusGroups['*']
      for (let i = 0; i < this.groupStatuses.length; i++) {
        this.statuses.push(this.systemStatuses[this.groupStatuses[i]])
      }
    }
  }
}
</script>

<style scoped>

</style>
